<template>
	<input-form action="/json/login" @submit="$emit('submit', $event)" @loading="$emit('loading', $event)" :unsaveable="true" v-slot="props">
		<input-text ref="start" v-model="props.object.username" :errors="props.errors.username" label="Username" prepend-icon="email" inputmode="email" placeholder="Email address or username"></input-text>
		<input-password v-model="props.object.password" :errors="props.errors.password" label="Password" placeholder="Password" prepend-icon="lock"></input-password>
		<button type="submit" :disabled="props.loading > 0" class="secondary block">Log In</button>
		<a href="#" @click.prevent="$emit('forgot')">Forgot Password</a>
	</input-form>
</template>

<script>
	export default {
		mounted() {
			this.$refs.start.focus();
		}
	}
</script>